"use client";

import { Routes } from "@/api";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
} from "@/components/ui/modal";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { PropsWithChildren } from "react";

import { Skeleton } from "../ui/skeleton";
import { UserAuthForm } from "./user-auth-form";

export const useAuthDialogProps = (
   
  onOpenChangeCb?: (open: boolean) => void,
) => {
  const [open, setOpen] = React.useState(false);

  const onOpenChange = (open: boolean) => {
    setOpen(open);

    onOpenChangeCb?.(open);
  };

  return {
    open,
    onOpenChange,
  };
};

interface Props {
   
  readonly onOpenChange: (open: boolean) => void;
  readonly open: boolean;
  readonly callbackUrl?: string;
}

function AuthDialogClient(props: Props) {
  return (
    <Modal open={props.open} onOpenChange={props.onOpenChange} isRoute={false}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle className="text-xl font-bold">Log in for FREE</ModalTitle>
        </ModalHeader>
        <AuthDialogContent callbackUrl={props.callbackUrl}>
          <AuthDialogConsent />
        </AuthDialogContent>
      </ModalContent>
    </Modal>
  );
}

export function AuthDialogContent(
  props: PropsWithChildren<Pick<Props, "callbackUrl">>,
) {
  const pathname = usePathname();

  const callbackUrl = React.useMemo(() => {
    if (props.callbackUrl) {
      return props.callbackUrl;
    }

    return pathname;
  }, [pathname, props.callbackUrl]);

  return (
    <>
      <UserAuthForm callbackUrl={callbackUrl} />
      {props.children}
    </>
  );
}

export function AuthDialogConsent() {
  return (
    <p className="px-8 text-center text-sm">
      By continuing, you agree to our{" "}
      <Link
        href={Routes.TERMS}
        target="_blank"
        className="underline underline-offset-4"
      >
        Terms
      </Link>{" "}
      and{" "}
      <Link
        href={Routes.PRIVACY}
        target="_blank"
        className="underline underline-offset-4"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
}

export function AuthDialog(props: Props) {
  return (
    <React.Suspense fallback={<Skeleton className="h-full w-full" />}>
      <AuthDialogClient {...props} />
    </React.Suspense>
  );
}
